import {createContext} from 'react'
const  StoreContext = createContext({});
export default StoreContext;